/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Type_TvInputs */

const en_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TV Parental Guideline`)
};

const fr_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommandations parentales pour la télévision`)
};

const de_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TV-Elternrichtlinien`)
};

const it_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linee guida per i genitori in TV`)
};

const ru_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендации для родителей по просмотру телепередач`)
};

const es_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía para padres sobre televisión`)
};

const zh_cn2_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电视节目家长指导`)
};

const ja_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テレビのペアレンタルガイドライン`)
};

const hi_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीवी अभिभावक दिशानिर्देश`)
};

const pt_pt2_subtitle_export_vchip_type_tv = /** @type {(inputs: Subtitle_Export_Vchip_Type_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diretrizes parentais para TV`)
};

/**
* | output |
* | --- |
* | "TV Parental Guideline" |
*
* @param {Subtitle_Export_Vchip_Type_TvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_type_tv = /** @type {((inputs?: Subtitle_Export_Vchip_Type_TvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Type_TvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_type_tv(inputs)
	if (locale === "de") return de_subtitle_export_vchip_type_tv(inputs)
	if (locale === "it") return it_subtitle_export_vchip_type_tv(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_type_tv(inputs)
	if (locale === "es") return es_subtitle_export_vchip_type_tv(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_type_tv(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_type_tv(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_type_tv(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_type_tv(inputs)
	return en_subtitle_export_vchip_type_tv(inputs)
});